import script from "./ExpandCollapseButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpandCollapseButton.vue?vue&type=script&setup=true&lang=js"

import "./ExpandCollapseButton.vue?vue&type=style&index=0&id=9db966f4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9db966f4"]])

export default __exports__